import { VIDEO_VARIANTS } from '@workspace/constants';
import { HeadingType } from '@workspace/lib/heading-utils';
import { cn } from '@workspace/lib';
import { AppVideoImage, Picture } from '@workspace/ui/common';
import { SanityImage } from '@workspace/interfaces';
import type { ProductSummaryMediaDimensions } from '../product-summary-layout';

interface ProductSummaryMediaProps {
  isVideo?: boolean;
  video?: string;
  image?: SanityImage;
  headline?: HeadingType;
  dimensions: ProductSummaryMediaDimensions;
  videoClassName: string;
  placeholderClassName: string;
}

export function ProductSummaryMedia({
  isVideo,
  video,
  image,
  headline,
  dimensions,
  videoClassName,
  placeholderClassName,
}: ProductSummaryMediaProps) {
  if (isVideo && video) {
    return <AppVideoImage variant={VIDEO_VARIANTS.VideoWithoutText} video={video} wrapperClassName={videoClassName} />;
  }

  if (!image?.asset?._ref && !image?.url) {
    return <div className={cn('flex items-center justify-center bg-light-silver', placeholderClassName)} />;
  }

  const altText =
    image?.bynderImage?.alt ||
    image?.alt ||
    (typeof headline === 'string' ? headline : headline?.headingText || 'Product image');

  return (
    <Picture
      image={image}
      alt={altText}
      desktopWidth={dimensions.desktopWidth}
      desktopHeight={dimensions.desktopHeight}
      mobileWidth={dimensions.mobileWidth}
      mobileHeight={dimensions.mobileHeight}
      className="w-full h-full"
      imgClassName="w-full h-full object-cover"
    />
  );
}
